export const initialValues = {
  property_details: {
    logo: "",
    partnership_label: "",
    landlord: "",
    utilities_available: {
      electricity: true,
      heat: true,
      water_waste: true,
    },
    utilities_paid_by_tenant: {
      electricity: false,
      heat: false,
      water_waste: false,
    },
    pet_fees: {
      cat_fee: false,
      dog_fee: false,
      other_fee: false,
    },
    allowed_pets: {
      dogs: true,
      cats: true,
      others: true
    },
    property_name: "",
    building_name: "",
    unit_no: "",
    address: "",
    city: "",
    province: "",
    postal_code: "",
    appliances: "",
  },
  manager: {
    first_name: "",
    last_name: "",
    phone_no: "",
    email: "",
    signature: "",
    date: "",
  },
  tenants: [
    {
      id: "",
      name: "",
      email: "",
      signature: "",
      date: "",
    },
  ],
  occupants: [],
  lease_details: {
    start_date: "",
    end_date: "",
    basic_rent: "",
    pets: [],
    parking: [],
    storage: [],
    pro_ration: {
      date_of_early_move_in: "",
      amount_applicable: "",
      amount_to_be_charged: "",
    },
    telus: {
      charges: 0,
      included: false,
    },
    utilities: {
      heat_fee: 0,
      water_waste_fee: 0,
      electricity_fee: 0,
    },
    incentives: "",
  },
  security_deposits: {
    refundable: "",
    non_refundable: "",
    received_date: ""
  },
  attached_documents: [],
  additional_notes: "",
  mode: null,
  isActive: false
};


export const lease_modes_allowed = {
  new_lease: 'New Lease',
  release_request: 'Re-lease Request',
  scheduled: 'Scheduled Lease',
};